import React from "react";

interface ProjectMembersProps {
  formData: {
    topicChair: string;
    chairName: string;
    chairGender: string;
    chairAcademicTitle: string;
    chairAcademicDegree: string;
    chairResearchTitle: string;
    chairRank: string;
    chairWorkUnit: string;
    topicSecretary: string;
    secretaryName: string;
    secretaryGender: string;
    secretaryAcademicTitle: string;
    secretaryAcademicDegree: string;
    secretaryResearchTitle: string;
    secretaryRank: string;
    secretaryWorkUnit: string;
  };
  handleInputChange: (field: string, value: string) => void;
}

const ProjectMembers: React.FC<ProjectMembersProps> = ({
  formData,
  handleInputChange,
}) => {
  return (
    <div className="bg-gray-50 p-6 rounded-lg">
      {/* Chủ nhiệm đề tài */}
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mb-4">
        {/* Chủ nhiệm đề tài */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Chủ nhiệm đề tài:
          </label>
          <select
            value={formData.topicChair}
            onChange={(e) =>
              handleInputChange("topicChair", e.target.value)
            }
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="">- Chọn chủ nhiệm đề tài -</option>
            <option value="chair1">Nguyễn Văn A</option>
            <option value="chair2">Trần Thị B</option>
            <option value="chair3">Lê Văn C</option>
          </select>
        </div>

        {/* Tên chủ nhiệm */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Tên chủ nhiệm <span className="text-red-500">(*)</span>
          </label>
          <input
            type="text"
            value={formData.chairName}
            onChange={(e) =>
              handleInputChange("chairName", e.target.value)
            }
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Nhập tên chủ nhiệm..."
          />
        </div>

        {/* Cột 3: Giới tính và Học hàm - 2 input ngang hàng */}
        <div>
          <div className="grid grid-cols-2 gap-2 mb-2">
            <label className="block text-sm font-medium text-gray-700">
              Giới tính
            </label>
            <label className="block text-sm font-medium text-gray-700">
              Học hàm:
            </label>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <select
              value={formData.chairGender}
              onChange={(e) =>
                handleInputChange("chairGender", e.target.value)
              }
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="">- Giới tính -</option>
              <option value="male">Nam</option>
              <option value="female">Nữ</option>
            </select>

            <select
              value={formData.chairAcademicTitle}
              onChange={(e) =>
                handleInputChange("chairAcademicTitle", e.target.value)
              }
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="">- Học hàm -</option>
              <option value="professor">Giáo sư</option>
              <option value="associate-professor">Phó Giáo sư</option>
            </select>
          </div>
        </div>

        {/* Học vị */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Học vị
          </label>
          <select
            value={formData.chairAcademicDegree}
            onChange={(e) =>
              handleInputChange("chairAcademicDegree", e.target.value)
            }
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="">- Học vị -</option>
            <option value="phd">Tiến sĩ</option>
            <option value="master">Thạc sĩ</option>
            <option value="bachelor">Cử nhân</option>
          </select>
        </div>
      </div>

      {/* Row 7 - Chủ nhiệm */}
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mb-4">
        {/* Chức danh nghiên cứu */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Chức danh nghiên cứu:
          </label>
          <select
            value={formData.chairResearchTitle}
            onChange={(e) =>
              handleInputChange("chairResearchTitle", e.target.value)
            }
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="">- Chọn -</option>
            <option value="researcher">Nghiên cứu viên</option>
            <option value="senior-researcher">Nghiên cứu viên chính</option>
            <option value="principal-researcher">
              Nghiên cứu viên cao cấp
            </option>
          </select>
        </div>

        {/* Cấp bậc */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Cấp bậc:
          </label>
          <select
            value={formData.chairRank}
            onChange={(e) => handleInputChange("chairRank", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="">- Cấp bậc -</option>
            <option value="rank1">Cấp 1</option>
            <option value="rank2">Cấp 2</option>
            <option value="rank3">Cấp 3</option>
          </select>
        </div>

        {/* Đơn vị công tác */}
        <div className="col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Đơn vị công tác
          </label>
          <input
            type="text"
            value={formData.chairWorkUnit}
            onChange={(e) =>
              handleInputChange("chairWorkUnit", e.target.value)
            }
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Nhập đơn vị công tác..."
          />
        </div>
      </div>

      {/* Row 8 - Thư ký đề tài */}
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mb-4">
        {/* Thư ký đề tài */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Thư ký đề tài:
          </label>
          <select
            value={formData.topicSecretary}
            onChange={(e) =>
              handleInputChange("topicSecretary", e.target.value)
            }
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="">- Chọn thư ký đề tài -</option>
            <option value="secretary1">Phạm Văn D</option>
            <option value="secretary2">Hoàng Thị E</option>
            <option value="secretary3">Vũ Văn F</option>
          </select>
        </div>

        {/* Tên thư ký */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Tên thư ký
          </label>
          <input
            type="text"
            value={formData.secretaryName}
            onChange={(e) =>
              handleInputChange("secretaryName", e.target.value)
            }
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Nhập tên thư ký..."
          />
        </div>

        {/* Cột 3: Giới tính và Học hàm - 2 input ngang hàng */}
        <div>
          <div className="grid grid-cols-2 gap-2 mb-2">
            <label className="block text-sm font-medium text-gray-700">
              Giới tính
            </label>
            <label className="block text-sm font-medium text-gray-700">
              Học hàm:
            </label>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <select
              value={formData.secretaryGender}
              onChange={(e) =>
                handleInputChange("secretaryGender", e.target.value)
              }
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="">- Giới tính -</option>
              <option value="male">Nam</option>
              <option value="female">Nữ</option>
            </select>

            <select
              value={formData.secretaryAcademicTitle}
              onChange={(e) =>
                handleInputChange("secretaryAcademicTitle", e.target.value)
              }
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="">- Học hàm -</option>
              <option value="professor">Giáo sư</option>
              <option value="associate-professor">Phó Giáo sư</option>
            </select>
          </div>
        </div>

        {/* Học vị */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Học vị
          </label>
          <select
            value={formData.secretaryAcademicDegree}
            onChange={(e) =>
              handleInputChange("secretaryAcademicDegree", e.target.value)
            }
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="">- Học vị -</option>
            <option value="phd">Tiến sĩ</option>
            <option value="master">Thạc sĩ</option>
            <option value="bachelor">Cử nhân</option>
          </select>
        </div>
      </div>

      {/* Row 9 - Additional fields for secretary */}
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mb-4">
        {/* Chức danh nghiên cứu */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Chức danh nghiên cứu:
          </label>
          <select
            value={formData.secretaryResearchTitle}
            onChange={(e) =>
              handleInputChange("secretaryResearchTitle", e.target.value)
            }
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="">- Chọn -</option>
            <option value="researcher">Nghiên cứu viên</option>
            <option value="senior-researcher">Nghiên cứu viên chính</option>
            <option value="principal-researcher">
              Nghiên cứu viên cao cấp
            </option>
          </select>
        </div>

        {/* Cấp bậc */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Cấp bậc:
          </label>
          <select
            value={formData.secretaryRank}
            onChange={(e) => handleInputChange("secretaryRank", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="">- Cấp bậc -</option>
            <option value="rank1">Cấp 1</option>
            <option value="rank2">Cấp 2</option>
            <option value="rank3">Cấp 3</option>
          </select>
        </div>

        {/* Đơn vị công tác */}
        <div className="col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Đơn vị công tác
          </label>
          <input
            type="text"
            value={formData.secretaryWorkUnit}
            onChange={(e) =>
              handleInputChange("secretaryWorkUnit", e.target.value)
            }
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Nhập đơn vị công tác..."
          />
        </div>
      </div>
    </div>
  );
};

export default ProjectMembers;
